import { Callout, Intent, Spinner } from "@blueprintjs/core";
import styled from "@emotion/styled";

import { WorkspaceInvitationBatchesStatus } from "@/graphql";

interface ProcessingNewUsersCalloutProps {
  status: WorkspaceInvitationBatchesStatus;
  isProgram?: boolean;
}

const CALLOUT_PROFILE_BY_STATUS: Record<
  WorkspaceInvitationBatchesStatus,
  { title: string; intent: Intent; message: string }
> = {
  [WorkspaceInvitationBatchesStatus.InProgress]: {
    title: "Processing new users",
    intent: "primary",
    message:
      "New users were recently added to your account. Our systems are humming along setting up their accounts and sending invitations. This won't take too long!",
  },
  [WorkspaceInvitationBatchesStatus.Completed]: {
    title: "",
    intent: "success",
    message: "",
  },
};

const PROGRAM_CALLOUT_PROFILE_BY_STATUS: Record<
  WorkspaceInvitationBatchesStatus,
  { title: string; intent: Intent; message: string }
> = {
  [WorkspaceInvitationBatchesStatus.InProgress]: {
    title: "Processing new users",
    intent: "primary",
    message:
      "New users were recently added to your account. Our systems are humming along setting up their accounts. This won't take too long!",
  },
  [WorkspaceInvitationBatchesStatus.Completed]: {
    title: "",
    intent: "success",
    message: "",
  },
};

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
`;

const ContentWrapper = styled.div`
  flex: 1;
`;

const Title = styled.h4`
  margin: 0 0 7px;
  font-size: 16px;
  font-weight: 600;
`;

export function AddNewUsersCallout({
  status,
  isProgram = false,
}: ProcessingNewUsersCalloutProps) {
  const calloutProfile = isProgram
    ? PROGRAM_CALLOUT_PROFILE_BY_STATUS[status]
    : CALLOUT_PROFILE_BY_STATUS[status];
  return (
    <Callout intent={calloutProfile.intent} icon={false}>
      <Container>
        <Spinner size={20} intent={calloutProfile.intent} />
        <ContentWrapper>
          <Title>{calloutProfile.title}</Title>
          <span>{calloutProfile.message}</span>
        </ContentWrapper>
      </Container>
    </Callout>
  );
}
